/**
 * @fileoverview Agent definition for divergence-report-short-v1.
 *
 * Short-form variant of divergence analysis. Compares the author's planned
 * outline against the single written chapter, focusing on plot drift,
 * character arc drift, and plot thread status. No storyline or beat-level
 * analysis — those concepts don't apply to short stories.
 *
 * Reports are ephemeral — generated on demand, not persisted.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'divergence-report-short-v1',
  kind: 'primitive',
  name: 'Divergence Report (Short)',
  description: 'Analyzes divergences between the planned outline and the written draft for short stories.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'primitives/use-divergence-report-short-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'divergence-report-v2',
      'plot-snapshotter-v2',
    ],
  },
};
